// extracted by mini-css-extract-plugin
export default {"list":"JtNyF2FpnGcJIx7sFBResw==","smallSpacing":"_73UND3VB5jHOMrmq4DpJWA=="};